import { Subject } from "rxjs";

const info = {
  meeting: {
    ///  加载会议信息完成
    initEdn: new Subject(),
    mettingEnd: new Subject(),
    mettingChange: new Subject(),
  },
  ppt: {
    thirdSubscribe: new Subject(), //三方象ppt发的订阅消息 转发到模板
  },
  sdk: {
    // 初始化ppt完成
    initEnd: new Subject(),
    //视频是否推流中
    videoStatus: new Subject(),
    //三方象sdk发的订阅消息 转发到模板
    thirdSubscribe: new Subject(),
  },
  user: {
    /// 重新赋值人的信息 信息完成
    userInfoChange: new Subject(),
    //设置用户名称
    setUserName: new Subject(),
    userEnd: new Subject(),
  },
};

export default info;
